import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { LoginDialogCommandHandler } from './service/login-dialog.commands';
import { LoginDialogService, LoginDialogServiceImpl } from './service/login-dialog-service';
import { CommandContribution } from '@patsnap/tahiti-core';

/**
 * Login 相关服务的依赖注入模块
 * 默认使用 LoginDialogServiceImplV2（SDK 集成方式）
 * 如需使用 iframe 方式，请将绑定改为 LoginDialogServiceImpl
 */
export const loginModule = new ContainerModule((bind) => {
    // 绑定登录对话框服务（使用 SDK 方式）
    bind(LoginDialogService).to(LoginDialogServiceImpl);
    // 如需使用 iframe 方式，请使用以下绑定：
    // bind(LoginDialogService).to(LoginDialogServiceImpl);

    // 绑定命令处理器
    bind(CommandContribution).to(LoginDialogCommandHandler);
});

export { LoginDialogCommandHandler } from './service/login-dialog.commands';
export { LoginDialogService, LoginDialogServiceImpl } from './service/login-dialog-service';
export type { LoginDialogOptions, LoginDialogResult } from './service/login-dialog-service';
